"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCovid = createCovid;
const events_1 = require("../../../events");
const utils_1 = require("../../../events/utils");
const covidDisease_1 = require("../../../forms/ktx/transplantation-screening/medical-history/covid/covidDisease");
const covidVaccination_1 = require("../../../forms/ktx/transplantation-screening/medical-history/covid/covidVaccination");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    covid: {
        id: "ktx.dashboard.covid",
        defaultMessage: "Covid"
    },
    vaccination: {
        id: "ktx.dashboard.covid.vaccination",
        defaultMessage: "Vakcináció"
    },
    disease: {
        id: "ktx.dashboard.covid.disease",
        defaultMessage: "COVID betegségen átesett?"
    }
};
function createCovid(intl, options) {
    const vaccination = createVaccination(intl, options);
    const disease = createDisease(intl, options);
    const content = (0, shared_1.createSectionContent)([vaccination, disease]);
    return (0, shared_1.createSection)(intl, { label: messages.covid, content });
}
function createDisease({ formatMessage, formatMessageMap }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.covidQueries.disease);
    if (event === undefined) {
        return undefined;
    }
    const ever = {
        type: "list-item",
        value: formatMessageMap(covidDisease_1.everCovidDiseaseMessages, event.value.everCovidDisease)
    };
    const items = [ever];
    const { origin } = event;
    return {
        type: "list",
        attachments: (0, events_1.mapEventsToAttachments)(event),
        label: formatMessage(messages.disease),
        origin,
        items
    };
}
function createVaccination(intl, { events }) {
    const { formatMessageMap, formatDate } = intl;
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.covidQueries.vaccination);
    const list = relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        const items = [];
        items.push({
            type: "list-item",
            value: formatMessageMap(covidVaccination_1.vaccinationTypeMessages, event.value)
        });
        return {
            type: "list",
            attachments: (0, events_1.mapEventsToAttachments)(event),
            label: formattedTimestamp,
            timestamp: event.timestamp,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
    const content = (0, shared_1.createGroupContent)(list);
    return (0, shared_1.createGroup)(intl, { label: messages.vaccination, content });
}
